import { Component, Inject } from '@angular/core';

import Env from '@ridango/core/env';
import { NetworkService, BaseComponent } from '@ridango/core';

/**
 * Displays alert when internet connection is broken.
 */
@Component({
    selector: 'rwidget-no-internet-alert',
    templateUrl: './no-internet-alert.component.html',
    styleUrls: ['./no-internet-alert.component.scss']
})
export class NoInternetAlertComponent extends BaseComponent {
    isOnline$ = this.networkService.getStatus();

    constructor(
        @Inject('ENV') public env: Env,
        private networkService: NetworkService
    ) {
        super();
    }
}
